import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { SherpaCustomersOrdersDetailView } from './detail/detail';

export const SherpaCustomersOrdersView = angular
  .module('acme.view.application.sherpa.customers.orders', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.sherpa.customers.orders.controllers',
    SherpaCustomersOrdersDetailView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.sherpa.customers.orders',
      url: '/orders/:id?type&orderNumber',
      views: {
        'subview-main': {
          controller: 'SherpaCustomersOrdersController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/sherpa/customers/orders/orders.tpl.html',
        },
      },
      data: {
        pageTitle: 'CSR Customer Orders',
      },
    });
  }).name;
